<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="exi">FROM:</p>
<p class="exi">DIANE BERG</p>
<p class="exi-bot">GENEVA</p>
<p class="exi">TO:</p>
<p class="exi">DR WARGNIER</p>
<p class="exi">WARGNIER PSYCHIATRIC INSTITUTE</p>
<p class="exi-bot">SAINT-MARTIN-DE-COMMINGES</p>
<p class="exi">Diane Berg – Curriculum vitae</p>
<p class="exi">Psychologist, Swiss Federation of Psychologists (FSP)</p>
<p class="exi-bot">Specialist in Forensic Psychology (SSPL)</p>
<p class="exi">Date of Birth: 16 July 1976</p>
<p class="exi-bot">Nationality: Swiss</p>
<p class="exi">D<span class="epub-sc">IPLOMAS</span>:</p>
<p class="exi">2002: Master of advanced studies in clinical psychology (DES), University of Geneva. Dissertation: ‘Instinctual Economy, Necrophilia and Dismembering among Compulsive Killers’.</p>
<p class="exi">1999: Degree in psychology, University of Geneva. Dissertation: ‘Aspects of Childhood Fear among Children Eight to Twelve Years of Age’.</p>
<p class="exi">1995: Secondary School Diploma in classical and Latin studies</p>
<p class="exi-bot">1994: Cambridge First Certificate in English as a foreign language</p>
<p class="exi">P<span class="epub-sc">ROFESSIONAL</span> E<span class="epub-sc">XPERIENCE</span>:</p>
<p class="exi">2003 – present: Private Practice, psychotherapy and forensic psychology, Geneva</p>
<p class="exi">2001 – present: Assistant to Professor Pierre Spitzner at the Faculty of Psychology and Educational Sciences (FPSE), University of Geneva</p>
<p class="exi">1999–2001: Intern in psychology, Institute of Forensic Psychology, University of Geneva</p>
<p class="exi-bot">Intern in psychology, Medical Services of Champ-Dollon Prison</p>
<p class="exi">P<span class="epub-sc">ROFESSIONAL</span> A<span class="epub-sc">SSOCIATIONS</span>:</p>
<p class="exi">International Academy of Law and Mental Health (IALMH)</p>
<p class="exi">Geneva Association of Psychologists-Psychotherapists (AGPP)</p>
<p class="exi">Swiss Federation of Psychologists (FSP)</p>
<p class="exi-bot">Swiss Society of Forensic Psychology (SSPL)</p>
<p class="exi">I<span class="epub-sc">NTERESTS</span>:</p>
<p class="exi">Classical music (ten years of violin), jazz, reading</p>
<p class="exi">Sports: swimming, running, diving, potholing, parachute jumping</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?6b87f557